import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { BasefieldV2Component } from '@app/formly/types/v2/basefield-v2/basefield-v2.component';
import { UntilDestroy, UntilDestroyed } from '@app/shared/utils/until-destroy';
import { DropdownItem } from '@voyagu/radar-design-system';
import { DropdownType } from '@ui/components/dropdown/dropdown.component';
import { take } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'select-v2',
  templateUrl: './select-v2.component.html',
  styleUrls: ['./select-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectV2Component extends BasefieldV2Component implements OnInit {
  selectedItem: DropdownItem;
  dropdownType = DropdownType;

  items: DropdownItem[] = [];

  loading = false;

  constructor(private cdRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    this.setInitial();
  }

  setInitial() {
    if (this.props.initial) {
      this.selectedItem = this.props.initial;
    }
  }

  optionSelected(item: DropdownItem): void {
    this.selectedItem = item;

    if (this.props.emitFullObject) {
      this.formControl.setValue(item);
    } else {
      this.formControl.setValue(item?.value);
    }

    this.formControl.markAsDirty();
  }

  onCollapse(collapsed: boolean) {
    if (collapsed) {
      return;
    }

    if (this.items.length) {
      return;
    }

    this.loading = true;
    this.props.optionsService
      .pipe(take(1), UntilDestroyed(this))
      .subscribe((items: DropdownItem[]) => {
        this.items = items ?? [];
        this.loading = false;
        // markForCheck, not detectChanges: sync CD remounts the trigger under the
        // opening click and DropdownAbstractClass treats it as an outside click.
        this.cdRef.markForCheck();
      });
  }
}
